import React, { forwardRef, useState } from 'react'
import { Select, Checkbox, Divider } from 'antd'
import { formatMessage } from '@/utils/common'

const SelectAll = forwardRef((props, ref) => {
  const { selectAllBack, showAll, allowClearFlag, selectList, initialValues, allLabel, ...resItem } = props
  let checkedall1 = false

  if (selectList && initialValues && props.mode === 'multiple') {
    let sel = initialValues
    let selLs = []
    for (let index = 0; index < sel.length; index++) {
      const element = sel[index]
      let selRes = selectList.findIndex(item => item.value === element)
      if (selRes !== -1) {
        selLs.push(element)
      }
    }
    checkedall1 = selectList.length === selLs.length && selLs.length > 0
  }

  const [checkedall, setCheckedall] = useState(checkedall1)
  const [checkedallDis, setCheckedallDis] = useState(false)

  const checkallChange = e => {
    let ls = selectList.map(item => item.value)
    if (!e.target.checked) {
      ls = []
    }
    setCheckedall(e.target.checked)
    selectAllBack && selectAllBack(ls)
    props.onChange && props.onChange(ls) // ✅ 调用外部 onChange
  }

  const isSelectAll = e => {
    let ls = selectList.map(item => item.value)
    if (props.mode === 'multiple' && e.length === ls.length) {
      setCheckedall(true)
    } else {
      setCheckedall(false)
    }
  }

  return (
    <>
      <Select
        showSearch
        style={{ width: '100%' }}
        placeholder={formatMessage('languageObj.commonLocale.placeholderSelect')}
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        allowClear={allowClearFlag}
        popupRender={menu => (
          <div>
            {showAll ? (
              <div>
                <div
                  style={{ padding: '4px 8px' }}
                  onMouseDown={e => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                >
                  <Checkbox
                    disabled={checkedallDis}
                    onClick={e => {
                      checkallChange(e)
                    }}
                    checked={checkedall}
                  >
                    {allLabel || formatMessage('languageObj.commonLocale.all')}
                  </Checkbox>
                </div>
                <Divider style={{ margin: '4px 0' }} />
              </div>
            ) : null}
            {menu}
          </div>
        )}
        {...resItem}
        onChange={e => {
          setCheckedallDis(false)
          isSelectAll(e)
          selectAllBack && selectAllBack(e)
          props.onChange && props.onChange(e) // ✅ 调用外部 onChange
        }}
        onSearch={e => {
          if (e) {
            setCheckedallDis(true)
          } else {
            setCheckedallDis(false)
          }
        }}
      >
        {selectList.map((itemSel, idxSel) => (
          <Select.Option key={idxSel} value={itemSel.value}>
            {itemSel.label}
          </Select.Option>
        ))}
      </Select>
    </>
  )
})

export default React.memo(SelectAll)
